import { defineStore } from 'pinia';
import { onBeforeMount, ref } from 'vue';
import { IDashboard } from '../services/api/dashboard/types';
import { useRoute, useRouter } from 'vue-router';
import { postShareDashboardPassword } from '../services/api/publicApi/publicApi';

export const usePublicLinkStore = defineStore('publicLink', () => {
    const route = useRoute();
    const router = useRouter();

    const externalId = ref<string | null>(null);
    const tenantName = ref<string | null>(null);
    const passwordRequired = ref<boolean | null>(null);
    const dashboard = ref<IDashboard | null>(null);

    const loading = ref<boolean>(false);
    const error = ref<boolean>(false);

    onBeforeMount(() => {
        externalId.value = route.query.shareId?.toString() ?? null;
        tenantName.value = route.query.tenantName?.toString() ?? null;

        if (!externalId.value || !tenantName.value) {
            router.push('/share-404');
        }

        passwordRequired.value = route.query.password === 'True' || route.query.password === 'true';
    });

    const getDashboard = async (password?: string) => {
        if (externalId.value === null || tenantName.value === null) {
            return;
        }
        loading.value = true;
        postShareDashboardPassword({
            externalId: externalId.value,
            tenantName: tenantName.value,
            password,
        })
            .then((res) => {
                dashboard.value = res;
                loading.value = false;
            })
            .catch((err) => {
                console.error('Error posting share dashboard password:', err);
                loading.value = false;
                error.value = true;
            });
    };

    return {
        externalId,
        dashboard,
        passwordRequired,
        loading,
        error,
        getDashboard,
    };
});
